import {
  Component,
  OnInit,
  ViewChild,
  Inject,
  AfterViewInit,
  ElementRef,
} from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  FormControl,
  Validators,
} from '@angular/forms';
import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { RemarkPopupComponent } from 'src/app/modals/remark-popup/remark-popup.component';
import { UserManagementService } from 'src/app/Service/user-management.service';
import { DatePipe } from '@angular/common';
import { DaterangepickerDirective } from 'ngx-daterangepicker-material';
import * as moment from 'moment';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { SelectionModel } from '@angular/cdk/collections';
import { Lightbox } from 'ng-gallery/lightbox';
import { NgxSpinnerService } from 'ngx-spinner';
import { MatSort, Sort } from '@angular/material/sort';
import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { MatChipInputEvent } from '@angular/material/chips';

export interface Element {
  title: string;
  description: string;
  videoURL: string;
  publishDate: string;
  categoryName: string;
  updatedBy: string;
  action: string;
}
@Component({
  selector: 'app-video-library',
  templateUrl: './video-library.component.html',
  styleUrls: ['./video-library.component.scss'],
})
export class VideoLibraryComponent implements OnInit {
  form = new FormGroup({
    start: new FormControl(),
    end: new FormControl(),
  });
  totalCount;
  avgCount: any = [];
  categorydata;
  categorydatalist;
  videoForm: FormGroup;
  formhide = false;
  exportcsvdata = false;
  listVideo;
  searchData: any;
  displayedColumns = [
    'publishDate',
    'title',
    'description',
    'categoryName',
    'videoUrl',
    'updatedBy',
    'languages',
    'action',
  ];

  languageList = [
    { value: 'te', viewValue: 'Telugu' },
    { value: 'ta', viewValue: 'Tamil' },
    { value: 'kn', viewValue: 'Kannada' },
    { value: 'ml', viewValue: 'Malayalam' },
    { value: 'en', viewValue: 'English' },
    { value: 'hi', viewValue: 'Hindi' },
  ];

  dataSource = new MatTableDataSource<Element>([]);
  //sorting table
  dataSourcelist;
  response;
  submitted = false;
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  customDate = false;
  //applyfilter
  filterbyText = '';
  public matChipArray = [];
  newData: any;
  sharedate: any;
  //date range
  dateRangeMaxDate = new Date();
  datepicker = [
    {
      value: '0',
      viewValue: '1 Week',
      startDate: new Date(new Date().setDate(new Date().getDate() - 7)),
      endDate: new Date(),
    },
    {
      value: '1',
      viewValue: '1 Months',
      startDate: new Date(new Date().setDate(new Date().getDate() - 30)),
      endDate: new Date(),
    },
    {
      value: '2',
      viewValue: '3 Months',
      startDate: new Date(new Date().setDate(new Date().getDate() - 90)),
      endDate: new Date(),
    },
    {
      value: '3',
      viewValue: '6 Months',
      startDate: new Date(new Date().setDate(new Date().getDate() - 180)),
      endDate: new Date(),
    },
    {
      value: '4',
      viewValue: '1 Year',
      startDate: new Date(new Date().setDate(new Date().getDate() - 365)),
      endDate: new Date(),
    },
  ];
  ranges: any = {
    '1 Week': [moment().subtract(6, 'days'), moment()],
    '1 Month': [moment().subtract(29, 'days'), moment()],
    '3 Months': [moment().subtract(59, 'days'), moment()],
    '6 Months': [moment().subtract(179, 'days'), moment()],
    '1 Year': [moment().subtract(364, 'days'), moment()],
  };
  maxDate;
  minDate;
  @ViewChild(DaterangepickerDirective, { static: false })
  pickerDirective: DaterangepickerDirective;
  // date range end
  constructor(
    private router: Router,
    public toastr: ToastrService,
    private fb: FormBuilder,
    private spinner: NgxSpinnerService,
    public lightbox: Lightbox,
    public _userService: UserManagementService,
    private datePipe: DatePipe,
    public dialog: MatDialog
  ) {}
  ngOnInit() {
    this.videoForm = this.fb.group({
      title: ['', [Validators.required]], //mandatory include document Attchment
      getdate: [new Date(), [Validators.required]],
      description: ['', [Validators.required]],
      category: ['', [Validators.required]], //mandatory
      videoURL: ['', [Validators.required]],
      source: ['', [Validators.required]],
      videoId: [''],
      languages: ['', [Validators.required]],
      categoryID: [''],
    });

    this.formInIt();
    this.spinner.show();
    setTimeout(() => {
      this.spinner.hide();
    }, 4000);
    this.getcategoryforFilter();
    this.GetTotalVideoCount();
    this.getVideoList();
  }

  //**************************TOTAL VIDEO COUNT ********************************** */
  GetTotalVideoCount() {
    this._userService.getAverageVideo().subscribe((data) => {
      this.totalCount = data;
      this.avgCount = this.totalCount.result.data;
    });
  }
  getcategoryforFilter() {
    this._userService.getVideoCategory().subscribe((data) => {
      this.categorydata = data;
      this.categorydatalist = this.categorydata.result.data;
    });
  }
  // **************************TABLE VALUE FETCH ************************
  getVideoList() {
    this.spinner.show();
    var postdata = {
      search: '',
      fromDate: '',
      todate: '',
      categoryID: '',
      languages: '',
      pageNumber: 0,
      pageSize: 10,
    };
    this._userService.getVideoList(postdata).subscribe((data) => {
      this.listVideo = data;
      this.paginationProperty = this.listVideo.result.data;
      this.length = this.paginationProperty.totalItems;
      this.previousPageIndex = this.paginationProperty.previousPageIndex;
      this.hasNextPage = this.paginationProperty.hasNextPage;
      this.hasPreviousPage = this.paginationProperty.hasPreviousPage;
      this.pageIndex = this.paginationProperty.pageNumber;
      this.totalPages = this.paginationProperty.totalPages;
      this.dataSource = new MatTableDataSource<Element>(
        this.listVideo.result.data.list
      );
      this.dataSource.sort = this.sort;
      this.spinner.hide();
    });
  }
  //**************************table value ****************************** */
  //******************************* START Pagination************************************ */
  paginationProperty;
  hasNextPage;
  hasPreviousPage;
  nextPageNumber;
  pageNumber;
  pageSize;
  previousPageNumber;
  totalItems;
  totalPages;
  pageEvent: PageEvent;
  datasource: null;
  pageIndex: number;
  length: number;
  filterForm: FormGroup;
  previousPageIndex;
  pagechangeevent;
  searchText = '';
  searchDate = '';
  public getServerData(event?: PageEvent) {
    this.pagechangeevent = event;
    this.pageIndex = this.pagechangeevent.pageIndex;
    this.length = this.pagechangeevent.length;
    this.pageSize = this.pagechangeevent.pageSize;

      var postdata = {
        search: this.filterbyText,
        pageNumber: this.pageIndex,
        pageSize: this.pageSize,
      };

      this._userService.getVideoList(postdata).subscribe((data) => {
        this.newData = data;
        this.paginationProperty = this.newData.result?.data;
        this.length = this.paginationProperty?.totalItems;
        this.previousPageIndex = this.paginationProperty?.previousPageIndex;
        this.hasNextPage = this.paginationProperty?.hasNextPage;
        this.hasPreviousPage = this.paginationProperty?.hasPreviousPage;
        this.pageIndex = this.paginationProperty?.pageNumber;
        this.totalPages = this.paginationProperty?.totalPages;
        this.dataSource = new MatTableDataSource<Element>(
          this.newData.result.data?.list
        );

        this.dataSource.sort = this.sort;
        this.spinner.hide();
      });
    }
  //******************************* END Pagination************************************ */
  //************************date ranged*********************************** */

  formInIt() {
    this.filterForm = new FormGroup({
      search: new FormControl(''),
      category: new FormControl(''),
      dateRange: new FormControl(),
      languages: new FormControl(),
    });
  }

  clearForm() {
    this.filterForm.reset();
    this.getVideoList();
  }

  filterDate(date) {
    return moment(date).format('L');
  }

  onSubmit(form) {}
  startdata;
  enddata;

  onDateRangeChanged(dates) {
    this.sharedate = dates;
    if (dates) {
      this.enddata = dates.endDate
        ? this.datePipe.transform(dates.endDate, 'yyyy/MM/dd hh:mm:ss')
        : null;
      this.startdata = dates.startDate
        ? this.datePipe.transform(dates.startDate, 'yyyy/MM/dd hh:mm:ss')
        : null;
    }
  }
  // Apply Filter implementation

  // applyfilter() {
  //   let body: any = {
  //     categoryID: "",
  //     fromDate: "",
  //     pageNumber: 0,
  //     pageSize: 10,
  //     search: this.searchData,
  //     todate: "",
  //   }
  //   this._userService.getVideoList(body).subscribe((res: any) => {
  //     this.dataSource = new MatTableDataSource<Element>(res.result.data.list);
  //   })
  // }
  filterbycategoryID = '';
  languageName = '';
  filterbyformdate = '';
  filterbytodayte = '';
  filterbysource = '';
  source: '';
  subProductName: '';
  filterbysubProductName: '';
  filterbysharedate = '';
  formdate = this.datePipe.transform(
    this.form.controls.start.value,
    'yyyy/MM/dd hh:mm:ss'
  );
  todayte = this.datePipe.transform(
    this.form.controls.end.value,
    'yyyy/MM/dd hh:mm:ss'
  );
  // -------------------------------------------------------------------------------------------
  applyfilter(checkEmpty) {
    // if (
    //   checkEmpty &&
    //   !this.filterForm.value.search &&
    //   !this.languageName &&
    //   !this.filterForm.value.dateRange.endDate &&
    //   !this.filterForm.value.dateRange.startDate
    // ) {
    //   alert('Please provide input first');
    // } else {

    this.exportcsvdata = true;
    this.filterbyText = this.searchData;
    this.filterbycategoryID = this.categorydata;
    this.filterbysource = this.source;
    this.filterbysharedate = this.sharedate;
    this.filterbyformdate = this.enddata;
    this.filterbytodayte = this.startdata;

    let indexlanguageName = this.matChipArray.findIndex(
      (x) => x.tag === 'languageName'
    );
    let indexsharedate = this.matChipArray.findIndex(
      (x) => x.tag === 'sharedate'
    );
    let indexformdate = this.matChipArray.findIndex(
      (x) => x.tag === 'formdate'
    );
    let indextodayte = this.matChipArray.findIndex((x) => x.tag === 'todayte');

    if (this.sharedate && this.startdata && this.enddata) {
      if (indexsharedate > -1) {
        this.matChipArray[indexsharedate].name =
          'Shared date' +
          ':' +
          (this.sharedate['startDate']
            ? this.sharedate['startDate'].format('MM/DD/YYYY')
            : '') +
          ' to ' +
          (this.sharedate['endDate']
            ? this.sharedate['endDate'].format('MM/DD/YYYY')
            : '');
      } else {
        this.matChipArray.push({
          name:
            'Shared date' +
            ':' +
            (this.sharedate['startDate']
              ? this.sharedate['startDate'].format('MM/DD/YYYY')
              : '') +
            ' to ' +
            (this.sharedate['endDate']
              ? this.sharedate['endDate'].format('MM/DD/YYYY')
              : ''),
          tag: 'sharedate',
          flag: true,
        });
      }
    }

    var postdata = {
      fromDate: this.filterForm.value.dateRange?.startDate
        ? this.filterDate(this.filterForm.value.dateRange?.startDate)
        : '',
      todate: this.filterForm.value.dateRange?.endDate
        ? this.filterDate(this.filterForm.value.dateRange?.endDate)
        : '',
      search: this.filterForm.value.search ? this.filterForm.value.search : '',
      categoryId: this.filterForm.value.category
        ? this.filterForm.value.category
        : '',
      languages: this.filterForm.value.languages
        ? this.filterForm.value.languages
        : '',
      pageNumber: 0,
      pageSize: 10,
    };

    this._userService.getVideoList(postdata).subscribe((data) => {
      this.newData = data;
      this.paginationProperty = this.newData.result?.data;
      this.length = this.paginationProperty?.totalItems;
      this.previousPageIndex = this.paginationProperty?.previousPageIndex;
      this.hasNextPage = this.paginationProperty?.hasNextPage;
      this.hasPreviousPage = this.paginationProperty?.hasPreviousPage;
      this.pageIndex = this.paginationProperty?.pageNumber;
      this.totalPages = this.paginationProperty?.totalPages;
      this.dataSource = new MatTableDataSource<Element>(
        this.newData.result.data?.list
      );

      this.dataSource.sort = this.sort;
      this.spinner.hide();
    });
    // }
  }

  //***********************remark Dialog open******************** */
  dialogresult;
  mainresult;
  openDialog(data): void {
    const dialogRef = this.dialog.open(DeleteVideoData, {
      // width: '30%',
      // height: '30%',
      data: { id: data },
    });

    dialogRef.afterClosed().subscribe((result) => {
      this.GetTotalVideoCount();
      this.getVideoList();
    });
  }
  //****************************post a video************************************* */
  formPage() {
    this.formhide = true;
    this.router.navigate(['/post-a-video']);
  }
  //*******************************EDIT********************************************* */
  listPage() {
    this.formhide = false;
  }
  listdata1;
  publishDate;

  dateformatConverter(date) {
    //  return  new Date(date).toLocaleString();
    // moment(Mon 03-Jul-2017, 11:00 AM, 'dd-mm-yyyy hh:mm').format('hh:mm A')
    return moment(date).format('MM/DD/YYYY');
    //  return new Date(date).toLocaleString().split(',')
  }

  simpleDateConverter(date) {
    moment.locale('fr');
    return moment(date).format('L');
    // let newDate= new Date(date)

    // return moment(newDate).format('DD/MM/YYYY');
    //  return new Date(date).toLocaleString().split(',')
  }

  get f() {
    return this.videoForm.controls;
  }

  edit(data1) {
    this.formhide = true;
    this.listdata1 = data1;

    const formattedDate = `${data1.publishDate.split('/')[1]}/${
      data1.publishDate.split('/')[0]
    }/${data1.publishDate.split('/')[2].split(' ')[0]}`;
    this.videoForm.get('videoId').setValue(data1.videoId);
    this.videoForm.get('title').setValue(data1.title);
    this.videoForm.get('source').setValue(data1.source);
    this.videoForm.get('description').setValue(data1.description);
    this.videoForm.get('getdate').setValue(new Date(String(formattedDate)));
    this.videoForm.get('videoURL').setValue(data1.videoURL);
    this.videoForm.get('category').setValue(data1.categoryName);
    this.videoForm.get('categoryID').setValue(data1.categoryID);
    this.videoForm.get('languages').setValue(data1.languages);
  }
  title;
  Remark;
  Source;
  onEditSubmit() {
    if (this.videoForm.valid) {
      let x;
      this.submitted = true;
      const ref = this.openRemarkDialog();
      ref.afterClosed().subscribe((data) => {
        x = data;
        let videoId = this.listdata1.videoId;
        this.spinner.show();
        let date = this.videoForm.controls.getdate.value;

        let langList = this.languageList
          .filter((x) => x.viewValue === this.videoForm.value.languages)
          .map((x) => x.value);

        var formdata = {
          title: this.videoForm.value.title,
          publishDate: this.dateformatConverter(date),
          videoURL: this.videoForm.value.videoURL,
          source: this.videoForm.value.source,
          description: this.videoForm.value.description,
          videoId,
          categoryID: this.videoForm.value.categoryID,
          languages: langList,
        };
        // if (confirm("Do you want to share this news?")) {
        this._userService.editVideo(formdata).subscribe((data: any) => {
          this.response = data;
          this.spinner.hide();
          this.toastr.success('Video updated successfully');
          this.getVideoList();
        });
        //}
        this.router.navigateByUrl('', { skipLocationChange: true }).then(() => {
          this.router.navigate(['/video-library']);
          this.getVideoList();
          this.spinner.hide();
        });
      });
    } else {
      return;
    }
  }
  getToday(): string {
    return new Date().toISOString().split('T')[0];
  }
  openRemarkDialog() {
    const dialogRef = this.dialog.open(RemarkPopupComponent, {});
    return dialogRef;
  }
  /*=================================================== Export Csv =============================================================================== */
  /*Export csv file */
  apidata;
  maindata;
  filename;
  selectItem(item) {
    if (item.value == 'Custom Date') {
      this.customDate = true;
    } else {
      this.customDate = false;
    }
  }
  openDialogexport(): void {
    const dialogRef = this.dialog.open(VideoExportData, {
      width: '60%',
      height: 'auto',
      //  data: {id: data}
    });
    dialogRef.afterClosed().subscribe((result) => {
      this.dialogresult = result;
      //================================REPORT GENERATE==========================================//
      if (this.dialogresult != undefined) {
        this.mainresult = JSON.parse(this.dialogresult.data);
        if (this.mainresult.length != 0) {
          let Result = this.mainresult.map((choice) => choice.value);

          let text = confirm('Are you sure you want to export this file?');
          if (text == true) {
            if (this.exportcsvdata == true) {
              // this.applyfilter(false);
              if (this.customDate == true) {
                var postdata = {
                  fromDate: this.formdate,
                  todate: this.todayte,
                  search: this.filterbyText,
                  category: this.filterbycategoryID,
                  languages: '',
                  reportList: Result,
                };
              } else {
                postdata = {
                  fromDate: this.startdata,
                  todate: this.enddata,
                  search: this.filterbyText,
                  category: this.filterbycategoryID,
                  languages: '',
                  reportList: Result,
                };
              }

              this._userService.exportVideo(postdata).subscribe((data) => {
                this.apidata = data;
                const blob = new Blob([this.apidata], {
                  type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                });
                const url = window.URL.createObjectURL(blob);
                var anchor = document.createElement('a');
                anchor.download = 'VideoDataList.xlsx';
                anchor.href = url;
                anchor.click();
              });
            } else {
              var postdata = {
                search: ' ',
                fromDate: '',
                todate: '',
                category: '',
                languages: '',
                reportList: Result,
              };
              this._userService.exportVideo(postdata).subscribe((data) => {
                this.apidata = data;
                const blob = new Blob([this.apidata], {
                  type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                });
                const url = window.URL.createObjectURL(blob);
                // window.open(url);
                var anchor = document.createElement('a');
                anchor.download = 'VideoDataList.xlsx';
                anchor.href = url;
                anchor.click();
              });
            }
          } else {
            this.openDialogexport();
          }
        } else {
          alert('Please select atleast any one column to generate report!');
          this.openDialogexport();
        }
      }
    });
  }
}

//**************************Delete**************************************** */
@Component({
  selector: 'delete-video-data',
  templateUrl: 'delete-video-data.html',
})
export class DeleteVideoData {
  formdelet: FormGroup;
  response;
  constructor(
    public dialogRef: MatDialogRef<DeleteVideoData>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder,
    public _userService: UserManagementService,
    public toastr: ToastrService,
    private router: Router
  ) {}
  onNoClick(): void {
    this.dialogRef.close();
  }
  ngOnInit(): void {
    this.formdelet = this.fb.group({
      Description: ['', [Validators.required]],
    });
  }
  onSubmit() {
    if (this.formdelet.valid) {
      var postdata = {
        videoId: this.data.id,
        description: this.formdelet.value.Description,
        //'description': this.data.description,
      };
      this._userService.romoveVideo(postdata).subscribe((data: any) => {
        this.response = data;
        this.toastr.success('Video removed successfully'),
          this.dialogRef.close();
      });
    } else {
      alert('Please enter valid remark !');
      return false;
    }
  }
}
//**************************Delete**************************************** */

//***************************export********************************************/
@Component({
  selector: 'video-export-data',
  templateUrl: 'video-export-data.html',
})
export class VideoExportData {
  response;
  title = 'Select/ Unselect All Checkboxes';
  masterSelected: boolean;
  checklist: any;
  checkedList: any;
  constructor(
    public dialogRef: MatDialogRef<VideoExportData>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder,
    public _userService: UserManagementService,
    public toastr: ToastrService,
    private router: Router
  ) {
    this.masterSelected = false;
    this.checklist = [
      { id: 1, viewValue: 'Title', value: 'Title', isSelected: false },
      { id: 2, viewValue: 'Source', value: 'Source', isSelected: false },
      { id: 5, viewValue: 'VideoURL', value: 'VideoURL', isSelected: false },
      {
        id: 3,
        viewValue: 'Description',
        value: 'Description',
        isSelected: false,
      },
      {
        id: 3,
        viewValue: 'PublishDate',
        value: 'PublishDate',
        isSelected: false,
      },
      { id: 7, viewValue: 'UpdatedBy', value: 'UpdatedBy', isSelected: false },
      {
        id: 6,
        viewValue: 'CategoryName',
        value: 'CategoryName',
        isSelected: false,
      },
      { id: 8, viewValue: 'Language', value: 'Languages', isSelected: false },
    ];
    this.getCheckedItemList();
  }

  ngOnInit(): void {}

  // The master checkbox will check/ uncheck all items
  checkUncheckAll() {
    for (var i = 0; i < this.checklist.length; i++) {
      this.checklist[i].isSelected = this.masterSelected;
    }
    this.getCheckedItemList();
  }

  // Check All Checkbox Checked
  isAllSelected() {
    this.masterSelected = this.checklist.every(function (item: any) {
      return item.isSelected == true;
    });
    this.getCheckedItemList();
  }
  // Get List of Checked Items
  getCheckedItemList() {
    this.checkedList = [];
    for (var i = 0; i < this.checklist.length; i++) {
      if (this.checklist[i].isSelected)
        this.checkedList.push(this.checklist[i]);
    }
    this.checkedList = JSON.stringify(this.checkedList);
  }
  closeDialog() {
    this.dialogRef.close({ data: this.checkedList });
  }
  closeDialogtest() {
    this.dialogRef.close();
  }
}
//***************************export********************************************/
